import SimMVPPopup from './SimMVPPopup';

export default SimMVPPopup;
